<template><!--导航栏-->
    <div class="home">

        <!--顶部导航栏  左和右-->
        <el-row class="bg-navigation">
            <el-col :sm="8" :md="6" :lg="4" :xl="4">
                <div class="bg-navigation-left">
                    <i class="el-icon-menu" v-if="this.$CookiesGet('type')===1"> 999 </i>
                    <i class="el-icon-menu" v-if="this.$CookiesGet('type')===2"> 999 </i>
                </div>
            </el-col>

            <el-col :sm="16" :md="18" :lg="20" :xl="20">
                <div class="bg-navigation-right">
                    <el-container>
                        <el-header>
                            <el-dropdown>
                                <div class="el-dropdown-link" style="font-size: 20px; color: white; margin-top: 15px;">
                                    {{account}} <i class="el-icon-arrow-down "></i>
                                </div>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item icon="el-icon-unlock" @click.native="changePassword()"
                                                      v-if="this.$CookiesGet('type')===2">修改登录密码
                                    </el-dropdown-item>
                                    <el-dropdown-item icon="el-icon-unlock" @click.native="payPassword()"
                                                      v-if="this.$CookiesGet('type')===2">修改支付密码
                                    </el-dropdown-item>
                                    <el-dropdown-item icon="el-icon-unlock" @click.native="logOut">安全退出
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </el-header>
                    </el-container>
                </div>
            </el-col>
        </el-row>

        <!--导航栏  左和右-->
        <div class="outer">
            <div class="left">
                <div class="bg-navigation-below-left" :style="conheight" style="width: 200px">
                    <menuLeft></menuLeft>
                </div>
            </div>

            <div class="right">
                <div class="bg-navigation-below-right">
                    <editableTabs ref="editableTabsRef"></editableTabs>
                    <keep-alive :exclude="closingPage">
                        <router-view></router-view>
                    </keep-alive>
                </div>
            </div>
        </div>

        <!--修改登录密码弹窗-->
        <el-dialog :visible.sync="dialogVisible" title="修改登录密码" width="500px" :close-on-click-modal=false>
            <div style="width: 400px;">
                <el-form ref="form" :model="ruleForm" label-width="110px">
                    <el-form-item label="原始密码: ">
                        <el-input show-password placeholder="请输入原始密码" v-model="ruleForm.oldPassword"></el-input>
                    </el-form-item>
                    <el-form-item label="输入密码: ">
                        <el-input show-password placeholder="请输入密码" v-model="ruleForm.password"></el-input>
                    </el-form-item>
                    <el-form-item label="确认密码: ">
                        <el-input show-password placeholder="请确认密码" v-model="ruleForm.isPassword"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div class="dialog-footer" slot="footer">
                <el-button type="primary" @click="changePassword">修改</el-button>
                <el-button type="primary" @click="dialogVisible = false">取消</el-button>
            </div>
        </el-dialog>

        <!--修改支付密码弹窗-->
        <el-dialog :visible.sync="payDialogVisible" title="修改支付密码" width="500px" :close-on-click-modal=false>
            <div style="width: 400px;">
                <el-form ref="form" :model="payRuleForm" label-width="110px">
                    <el-form-item label="原始密码: ">
                        <el-input show-password placeholder="请输入原始密码" v-model="payRuleForm.oldPassword"></el-input>
                    </el-form-item>
                    <el-form-item label="输入密码: ">
                        <el-input show-password placeholder="请输入密码" v-model="payRuleForm.password"></el-input>
                    </el-form-item>
                    <el-form-item label="确认密码: ">
                        <el-input show-password placeholder="请确认密码" v-model="payRuleForm.isPassword"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div class="dialog-footer" slot="footer">
                <el-button type="primary" @click="payPassword">修改</el-button>
                <el-button type="primary" @click="payDialogVisible = false">取消</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
    import menuLeft from '../views/Layout/menuLeft.vue'
    import editableTabs from '../views/Layout/editableTabs.vue'
    import {ChangePasswordApi, LogOutApi, PayPasswordApi} from "@/api/api";
    import {getToken} from "@/utils/dataStorage";

    export default {
        name: 'home',
        data() {
            return {
                show: true,
                account: '',    //  右上导航栏 登录人账号
                conheight: {       //   左侧导航栏高度
                    height: ''
                },
                dialogVisible: false,   //  修改登录密码弹窗
                ruleForm: {             //  修改登录密码弹窗属性
                    oldPassword: '',
                    password: '',
                    isPassword: '',
                },
                payDialogVisible: false,   //  修改交易密码弹窗
                payRuleForm: {             //  修改交易密码弹窗属性
                    oldPassword: '',
                    password: '',
                    isPassword: '',
                },
            };
        },
        methods: {
            //  修改登录密码
            changePassword() {
                if (!this.dialogVisible) {
                    this.dialogVisible = true;
                    this.ruleForm.oldPassword = "";
                    this.ruleForm.password = "";
                    this.ruleForm.isPassword = "";
                } else {
                    if (this.ruleForm.password !== this.ruleForm.isPassword) return this.$message.warning('修改的两次密码一致!');
                    if (!(this.ruleForm.password && this.ruleForm.oldPassword)) return this.$message.warning('密码为空!');
                    if (this.ruleForm.password === this.ruleForm.oldPassword) return this.$message.warning('两次密码一样!');

                    this.$confirm('此操作将重置密码, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        ChangePasswordApi({
                            newPwd: this.ruleForm.password,
                            oldPwd: this.ruleForm.oldPassword
                        })
                            // eslint-disable-next-line
                        .then(_ => {
                            this.$notify({
                                title: '成功',
                                message: "密码修改成功,请重新登录",
                                type: 'success'
                            });
                            this.dialogVisible = false;
                            this.$removeToken();
                            this.$router.push("/");
                        })
                            // eslint-disable-next-line
                            .catch(_ => {
                        });
                    }).catch(() => {
                    });
                }
            },
            //  修改支付密码
            payPassword() {
                if (!this.payDialogVisible) {
                    this.payRuleForm = {};
                    this.payDialogVisible = true;
                } else {
                    if (this.payRuleForm.password !== this.payRuleForm.isPassword) return this.$message.warning('修改的两次密码一致!');
                    if (!(this.payRuleForm.password && this.payRuleForm.oldPassword)) return this.$message.warning('密码为空!');
                    if (this.payRuleForm.password === this.payRuleForm.oldPassword) return this.$message.warning('两次密码一样!');

                    this.$confirm('此操作将重置密码, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        PayPasswordApi({
                            token: getToken(),
                            newpayPassword: this.payRuleForm.password,
                            payPassword: this.payRuleForm.oldPassword
                        })
                            // eslint-disable-next-line
                            .then(_ => {
                            this.$notify({
                                title: '成功',
                                message: "支付密码修改成功,即刻生效",
                                type: 'success'
                            });
                            this.payDialogVisible = false;
                        })
                            // eslint-disable-next-line
                            .catch(_ => {
                        });
                    }).catch(() => {
                    });
                }
            },
            //  退出登录
            logOut() {
                let type = this.$CookiesGet('type');
                LogOutApi({
                    type: type
                })
                //  eslint-disable-next-line
                    .then(_ => {
                    this.$removeToken();
                    this.$CookiesClear();

                    this.$notify({
                        title: "",
                        message: "账号退出成功",
                        type: 'success'
                    });
                    this.$router.push('/');
                })
                    // eslint-disable-next-line
                    .catch(_ => {
                    this.$router.push('/');
                });
            },
            getHeight() {
                this.conheight.height = window.innerHeight - 60 + 'px';
            },
        },
        created() {
            this.account = this.$CookiesGet('account');
            window.addEventListener('resize', this.getHeight);
            this.getHeight()
        },
        computed: {
            closingPage() {
                return this.$store.state.closingPage
            }
        },
        components: {
            menuLeft,
            editableTabs
        },
    }
</script>

<style>

    /*顶部导航栏*/
    .bg-navigation {
        background: #242F42;
        height: 60px;
        color: white;
    }

    /*顶部导航栏左*/
    .bg-navigation-left {
        font-size: 20px;
        margin-left: 20px;
        margin-top: 18px;
    }

    /*顶部导航栏右*/
    .bg-navigation-right {
        text-align: right;
    }

    /*内容左  左侧导航栏*/
    .bg-navigation-below-left {
        background: #324157;
        min-height: 948px;
    }

    /*内容右  右侧首页*/
    .bg-navigation-below-right {
        padding: 20px;
        background: #e5e9f2;
        min-height: 949px;
    }

    .outer {
        position: relative;
    }

    .left {
        position: absolute;
        left: 0;
        top: 0;
    }

    .right {
        margin-left: 200px;
    }

</style>
